import { render, staticRenderFns } from "./DonationItem.vue?vue&type=template&id=659c4b5d&scoped=true&"
import script from "./js/donation-item.js?vue&type=script&lang=js&"
export * from "./js/donation-item.js?vue&type=script&lang=js&"
import style0 from "./DonationItem.vue?vue&type=style&index=0&id=659c4b5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659c4b5d",
  null
  
)

export default component.exports